import * as React from 'react';
import styled from 'styled-components';
import { IMenuElement, IModalMenuElementsProps } from './menytypes';
import { MenuContext } from '.';
import { Arrow } from './arrow';
import { Link } from 'react-router-dom';
import { isExternalURL } from '../../../utils/helpers/url';

const PropStopLink = (props: {
  shouldPropStop: boolean;
  item: IMenuElement;
}) => {
  const context = React.useContext(MenuContext);
  const stopProp = (e: any) => {
    if (props.shouldPropStop) {
      e.stopPropagation();
    }
  };

  return isExternalURL(props.item.link).external ? (
    <a href={props.item.link} target="_blank" onClick={stopProp}>
      {props.item.name}
    </a>
  ) : (
    <Link
      to={`${props.item.link}`}
      onClick={() =>
        context.setMenuState({
          menuState: { modalVisible: false, searchVisible: false },
          setMenuState: null,
        })
      }
    >
      {props.item.name}
    </Link>
  );
};

export const ModalMenu = (props: IModalMenuElementsProps) => {
  const context = React.useContext(MenuContext);

  const [submenuVisible, setVisibleSubmenu]: [number | null, any] =
    React.useState(null);

  const [reset, setReset] = React.useState(true);

  const openMenu = (e: any) => {
    e.preventDefault();
    setVisibleSubmenu(null);
    const index = parseInt(e.currentTarget.getAttribute('data-submenu'), 10);
    if (index !== submenuVisible) {
      setVisibleSubmenu(index);
    }
  };

  const hasSubmenu = (item: IMenuElement): boolean => {
    return (item.subMenu && item.subMenu.length > 0) || false;
  };

  const stopProp = (e: any) => {
    e.stopPropagation();
  };

  return (
    <ModalMenuWrap>
      <MenuElementsWrap>
        <MenuUl>
          {props.menuelements?.map((item: IMenuElement, index: number) => {
            return (
              <li key={`meny_${index}`} onClick={openMenu} data-submenu={index}>
                <div style={{ minWidth: '280px' }}>
                  <PropStopLink
                    shouldPropStop={!hasSubmenu(item)}
                    item={item}
                  />
                  {hasSubmenu(item) && (
                    <Arrow open={index === submenuVisible} />
                  )}
                </div>
                <SubMenu>
                  {submenuVisible === index &&
                    item?.subMenu?.map((item: IMenuElement, index: number) => (
                      <li key={`sub_meny_${index}`}>
                        {isExternalURL(item.link).external ? (
                          <a
                            href={item.link}
                            target="_blank"
                            onClick={stopProp}
                          >
                            {item.name}
                          </a>
                        ) : (
                          <Link
                            to={item.link}
                            onClick={() => {
                              context.setMenuState({
                                menuState: {
                                  modalVisible: false,
                                  searchVisible: false,
                                },
                                setMenuState: null,
                              });
                            }}
                          >
                            {item.name}
                          </Link>
                        )}
                      </li>
                    ))}
                </SubMenu>
              </li>
            );
          })}
        </MenuUl>
        <BottomMenu>
          <a href="https://privatmegleren.no/personvern">Personvern</a>
        </BottomMenu>
      </MenuElementsWrap>
    </ModalMenuWrap>
  );
};

const ModalMenuWrap = styled.div`
  font-size: 18px;
  color: #fff;
  width: 100%;
  min-height: 100vh;
  padding: 2em 0;
  position: relative;
`;

const MenuUl = styled.ul`
  font-size: 27px;
  color: #fff;
  text-decoration: none;
  list-style: none;
  margin: 16px 0 0;
  padding: 0 0;
  li {
    cursor: pointer;
    margin: 0;
    padding: 0 0 10px 30px;
    text-align: left;
    @media (min-width: 1140px) {
      margin-right: 30px;
      padding: 0 0 10px 0;
    }
  }

  a {
    color: inherit;
    text-decoration: inherit;
    display: inline;
  }
`;

const MenuElementsWrap = styled.div``;

const BottomMenu = styled.div`
  padding: 0 0;
  margin: 90px 0 0 30px !important;
  text-align: left;

  @media (min-width: 1140px) {
    margin: 90px 0 0 !important;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
`;

const SubMenu = styled.ul`
  margin: 0.5em 0.5em 0 !important;
  padding: 0;
  li {
    list-style-type: none;
    font-size: 16px;
    padding-left: 0;
    padding-bottom: 6px;
  }
`;
